import { HUD } from '../../config/tuning';
import type { Projector, ScreenPoint } from '../../render/Camera';
import { createScreenPoint } from '../../render/Camera';
import type { HudPainter } from '../HudLayout';
import type { HudFrame } from '../HudFrame';

/**
 * The target designation mark (SPEC §3.4.1): a small red horizontal dash on the current aim
 * point in world space, drawn only when that point is actually in the camera frustum.
 *
 * This is the one element allowed a second colour. It is deliberately the *only* red thing on a
 * clean display, so "there is red on the screen" means "the aim point is in frame" without the
 * player having to look for it.
 */

const projected: ScreenPoint = createScreenPoint();

export function drawDesignation(
  painter: HudPainter,
  frame: HudFrame,
  projector: Projector,
): void {
  const point = frame.designationM;
  if (point === null) return;
  if (!projector.projectPoint(point, projected)) return;

  const layout = painter.layout;
  if (
    projected.x < 0 ||
    projected.x > layout.widthPx ||
    projected.y < 0 ||
    projected.y > layout.heightPx
  ) {
    return; // in the world but outside the frame: nothing to mark
  }

  const half = layout.px(HUD.designationLengthPx) * 0.5;
  painter.line(
    projected.x - half,
    projected.y,
    projected.x + half,
    projected.y,
    1.2,
    HUD.designationColour,
  );
}
